const pad = value => String(value).padStart(2, "0");

export const parseBirthdate = value => {
  if (!value) return null;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
  return { year, month, day, iso: `${year}-${pad(month)}-${pad(day)}` };
};

export const ageFromBirthdate = (value, now = new Date()) => {
  const parsed = parseBirthdate(value);
  if (!parsed) return null;
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  let age = year - parsed.year;
  if (month < parsed.month || (month === parsed.month && day < parsed.day)) age -= 1;
  return age;
};

export const birthdateValidation = (value, now = new Date(), minAge = 13, maxAge = 100) => {
  const parsed = parseBirthdate(value);
  if (!parsed) return { valid: false, message: "Fecha de nacimiento inválida" };
  const age = ageFromBirthdate(value, now);
  if (age < minAge || age > maxAge) return { valid: false, message: `Debes tener entre ${minAge} y ${maxAge} años` };
  return { valid: true, age, iso: parsed.iso };
};

export const profileAge = profile => {
  const fromBirthdate = ageFromBirthdate(profile?.fechaNacimiento || profile?.fecha_nacimiento);
  if (fromBirthdate !== null) return fromBirthdate;
  const legacy = Number(profile?.edad);
  return Number.isFinite(legacy) && legacy > 0 ? legacy : null;
};

export const birthdateInputMax = (now = new Date(), minAge = 13) => {
  const date = new Date(now.getFullYear() - minAge, now.getMonth(), now.getDate());
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
